import React from 'react';
import {withFirebase} from '../Firebase'

 //import * as serviceWorker from './ThingsWorker.js'
import worker from 'workerize-loader!./ThingsWorker.js'//eslint-disable-line import/no-webpack-loader-syntax


  function Clock (props){
    const {
      firebase,
      style={},
      hidden=false,
      onClick=()=>{},
      onContextMenu=()=>{},
      onDoubleClick=()=>{},
      onClockTick=()=>{},//millis
      onDayChange=()=>{},
      onStatusChange=()=>{},//0=init,1=ok,2=err,3=forbidden
      clockDisplay="hourly",//hourly,fulldate
    }=props
    const [milis,setMilis]=React.useState(0)
    const [currentDate,setCurrentDate]=React.useState("//")
    const [treshold,setTreshold]=React.useState(0)
    const [status,setStatus]=React.useState(0)//0:fetch,1:ok,2:err,3:forbidden
    const [retry,setRetry]=React.useState(0)
    const [textDate,setTextDate]=React.useState("...., .. ... ....")
    const workerRef=React.useRef()
    //const millisRef=React.useRef(0)
  
    React.useEffect(()=>{
      console.log("firebase.fn fetching...")
      setStatus(0)
      var getServerTime = firebase.fn.httpsCallable('getServerTime')
      getServerTime().then((result)=>{
        setMilis(result.data)
        setTreshold(result.data-new Date().getTime())
        setStatus(1)
        initWorker(result.data)
        //millisRef.current = result.data
        if(!!onClockTick)onClockTick(result.data)
      }).catch(e=>{
        setStatus(2)
        console.log("error tick 1 "+e)
      })
    },[retry])
    React.useEffect(()=>{
      var timerRetry
      if(status===2){
        //console.log("retryinng in 3s")
        timerRetry = setTimeout( () => {
          setRetry(retry+1)
        }, 60000 );
      }
      return function cleanup() {
          clearTimeout(timerRetry);
        };
    },[status])
  
    React.useEffect(()=>{
      if(!!onStatusChange)onStatusChange(status)
    },[status])
  
     React.useEffect(()=>{
      //console.log("set timer")
      var timerID = setTimeout( () => tick(), 1000 );
      return function cleanup() {
          clearTimeout(timerID);
        };
    },[milis ])//millisRef.current 
  
    function tick() {
      var mil=new Date().getTime()+treshold
      if(typeof(Worker)==="undefined"){
        alert("Not supported Web Browser")
        return
      }
      if(!workerRef.current){
        workerRef.current = worker()
      }
      workerRef.current.getMillis().then(milis=>{
        if(getDelta(mil,milis)>10000){
          setStatus(3)
          console.log("stopped at "+new Date(milis)+" valNow "+new Date())
          var getServerTime = firebase.fn.httpsCallable('getServerTime')
          getServerTime().then((result)=>{
            setMilis(result.data)
            setTreshold(result.data-new Date().getTime())
            setStatus(1)
            initWorker(result.data)
            //millisRef.current = result.data
            if(!!onClockTick)onClockTick(result.data)
          }).catch(e=>{
            setStatus(2)
            console.log("error tick 2 "+e)
          })
        }else{
          //millisRef.current = mil
          setMilis(mil);
          if(!!onClockTick)onClockTick(mil)
          var calcCurrentDate=toSimpleDateTimestamp(mil)// dt.getDate()
          if(calcCurrentDate!==currentDate){
            setCurrentDate(calcCurrentDate)
            if(!!onDayChange)onDayChange(calcCurrentDate)
          }
        }
      })

    }
    function initWorker(mil){
      if(typeof(Worker)==="undefined"){
        alert("Not supported Web Browser")
        return
      }
      if(!workerRef.current){
        workerRef.current = worker()
      }
      workerRef.current.init(mil).then(millll=>{
        console.log("initWorker"+millll)
        setMilis(millll)
      })
      workerRef.current.addEventListener('error',(evt)=>{
        alert("clock error "+evt)
      })
    }

    function getDelta(int1,int2){
      if(int1>int2){
        return int1-int2
      }else if(int2>int1){
        return int2-int1
      }else{
        return 0
      }
    }

    React.useEffect(()=>{
      if(currentDate==="//"||!currentDate)return
      var arr= currentDate.split("/")
      var year=parseInt(arr[0])
      var month=parseInt(arr[1])
      var day=parseInt(arr[2])
      var dt=new Date();
      dt.setFullYear(year,month-1,day)
      setTextDate(convertDayToName(dt.getDay())+", "+day+" "+convertMonthToName(month)+" "+year)
    },[currentDate])
    
    if(hidden)return null

    var dt=new Date(milis)
    return (
      status===0?
        <span onClick={onClick} onContextMenu={onContextMenu} onDoubleClick={onDoubleClick} style={style}>
          {clockDisplay==="hourly"?"..:..:..":"...., .. ... .... ..:..:.."}
        </span>
      :status===1?
      <span onClick={onClick} onContextMenu={onContextMenu} onDoubleClick={onDoubleClick} style={style}>{clockDisplay==="fulldate"&&textDate} {twoDigits(dt.getHours())+":"+twoDigits(dt.getMinutes())+":"+twoDigits(dt.getSeconds())}</span>
      :status===2?
      <span style={style} onClick={()=>{setRetry(retry+1)}} onContextMenu={onContextMenu} onDoubleClick={onDoubleClick} >retry</span>
      :<span onClick={onClick} onContextMenu={onContextMenu} onDoubleClick={onDoubleClick} style={style}>forbidden</span>
    )
  }

  function millisToTime(millis,mode=0){
    var res="",
    //ms=Math.floor((millis%1000)/100),
    //sec=Math.floor((millis/1000)%60),
    min=Math.floor((millis/60000)%60),
    hr=Math.floor((millis/3600000)%24)
    
    switch(mode){
      case 0:
        hr=(hr<10)?"0"+hr:hr
        min=(min<10)?"0"+min:min
        //sec=(sec<10)?"0"+sec:sec

        res=(hr!=="0"?hr+" jam ":"")+(min!=="00"?min+" menit ":"")
        break
      case 1:
        hr=hr.toString()
        min=min.toString()
        res=((hr!=="0"?hr+" jam ":"")+min+" menit ")
        break
    }
    

    return res
  }

  function convertDayToName(day,lang="IN"){
    var res=""
    switch(lang){
      case "IN":
        switch(day){
          case 0:
            res="Minggu"
            break
            case 1:
              res="Senin"
              break
            case 2:
              res="Selasa"
              break
            case 3:
              res="Rabu"
              break
            case 4:
              res="Kamis"
              break
            case 5:
              res="Jum'at"
              break
            case 6:
              res="Sabtu"
              break                                 
        }
        break;
      default:
    }
    return res
  }
  function convertMonthToName(month,lang="IN"){
    var res=""
    switch(lang){
      case "IN":
        switch(month){
          case 0:
            res="Code +1 please"
            break
            case 1:
              res="Januari"
              break
            case 2:
              res="Febuari"
              break
            case 3:
              res="Maret"
              break
            case 4:
              res="April"
              break
            case 5:
              res="Mei"
              break
            case 6:
              res="Juni"
              break      
            case 7:
              res="Juli"
              break      
            case 8:
              res="Agustus"
              break      
            case 9:
              res="September"
              break      
            case 10:
              res="Oktober"
              break      
            case 11:
              res="November"
              break      
            case 12:
              res="Desember"
              break      
                                                                            
        }
        break;
      default:
    }
    return res
  }
  function getDayLength(year,month){//januari=0
    var res=0
    switch(month){
      case 0:
        res=31
        break
      case 1:
        res=year%4===0?29:28
        break
      case 2:
        res=31
        break
      case 3:
        res=30
        break
      case 4:
        res=31
        break
      case 5:
        res=30
        break
      case 6:
        res=31
        break      
      case 7:
        res=31
        break      
      case 8:
        res=30
        break      
      case 9:
        res=31
        break      
      case 10:
        res=30
        break      
      case 11:
        res=31
        break
    }
    return res
  }

  function twoDigits(number){
    var result= !isNaN(parseFloat(number)) && isFinite(number)?number.toString():"0"
    if(result.length===1){
      result="0"+result
    }
    return ""+result
  }


  function toHour(milis,addHour){
    var dt=new Date(milis)
    if(!!addHour){
      dt.setHours(dt.getHours()+addHour)
    }
    return dt.getHours()
  }
  function toSimpleHourTimestamp(milis,addHour,addMinute){
    var dt=new Date(milis)
    if(!!addHour){
      dt.setHours(dt.getHours()+addHour)
    }
    if(!!addMinute){
      dt.setMinutes(dt.getMinutes()+addMinute)
    }
    
    return twoDigits(dt.getHours())+":"+twoDigits(dt.getMinutes())
  }
  function toHourTimestamp(milis){
    var dt=new Date(milis)
    return twoDigits(dt.getHours())+":"+twoDigits(dt.getMinutes())+":"+twoDigits(dt.getSeconds())
  }
  function toSimpleDateTimestamp(milis){
    var dt=new Date(milis)
    return dt.getFullYear()+"/"+twoDigits(dt.getMonth()+1)+"/"+twoDigits(dt.getDate())
  }
  function simpleDateTimestampToMillis(str){
    if(!str)return 0
    
    var arr=str.split("/")
    var year=arr[0]
    var month=arr[1]
    var date=arr[2]
    var dt=new Date()
    dt.setFullYear(year,parseInt(month)-1,parseInt(date))
    dt.setHours(1)

    return dt.getTime()

  }

  function toDateTimestamp(milis){
    var dt=new Date(milis)
    return dt.getFullYear()+"/"+twoDigits(dt.getMonth()+1)+"/"+twoDigits(dt.getDate())+" "+twoDigits(dt.getHours())+":"+twoDigits(dt.getMinutes())+":"+twoDigits(dt.getSeconds())
  }


  export {toHour,twoDigits,millisToTime,convertDayToName,convertMonthToName,getDayLength,toSimpleHourTimestamp,toHourTimestamp,toSimpleDateTimestamp,simpleDateTimestampToMillis,toDateTimestamp}
  export default withFirebase(Clock)

